export function isDevMode() {
    const value = localStorage.getItem('ct_dev_mode');
    return value && (['0', 0, 'off', false, 'false', ''].indexOf(value) === -1);
}

export function getLogger() {
    if (isDevMode()) {
        return console;
    }
    const dummy = () => void 0; /* eslint-disable-line no-void */
    return {
        debug: dummy,
        error: dummy,
        info: dummy,
        log: dummy,
        warn: dummy,
    };
}

export default {
    isDevMode,
    getLogger
};
